import axios from 'axios'
import { db, auth } from './firebase.js'

export default {
  // Check connection to Umbraco
  // Get all data from Umbraco
  async performSync(){
    console.log('sync initalized')
    const connected = await this.checkUmbracoConnection()
    if(connected){
      const umbracoData = await this.getUmbracoData()
      if(umbracoData){
        // We have the recipe data
        // Clear old data
        // await this.clearCollection()
        console.log('clear skipped')
        // Set new data
        await this.setCollection(umbracoData)
        console.log('data set')
        // Tell umbraco to handle images
        await this.initImageSync()
        console.log('images uploaded')
      }
    }
    return
  },

  async checkUmbracoConnection(){
    try{
      await axios.post(process.env.VUE_APP_BASE_API_URL + '/ContentApi/Settings')
      return true
    }
    catch(err) {
      return false
    }
  },

  async getUmbracoData(){
    return await axios.get(process.env.VUE_APP_BASE_API_URL + '/ContentApi/GetAllRecipes')
    .then((res) => { return res.data })
    .catch(() => { return null })
  },

  async clearCollection(){
    let i = 0
    await db.collection('RecipeData').get().then(res => {
      res.forEach(async element => { await element.ref.delete(), console.log('Recipe deleted:', i++) })
    })
  },

  async setCollection(umbracoData){
    let i = 0
    await auth.signInAnonymously().then(() => {
      umbracoData.forEach(async recipe => {
        await db.collection('RecipeData').doc(recipe.Id.toString()).set(recipe)
        console.log('Recipe uploaded:', i++)
      })
    })
  },

  async initImageSync(){
    await axios.post(process.env.VUE_APP_BASE_API_URL + '/ContentApi/SyncImages')
  }
}